<template>
  <div>
    <div style="display: grid; grid-template-columns: repeat(4, 1fr)">
      <div
        v-for="(statusValue, index) in modalStatuses"
        :key="`status${index}`"
        :data-testid="`status-${index}`"
        class="pt-1 lisaui:flex lisaui:flex-col lisaui:justify-center lisaui:gap-1"
        style="margin-top: -0.25rem; border-radius: var(--p-border-radius-md) !important"
        :class="{
          'lisaui:cursor-pointer': !props.disabled,
          'selected-status': multiStatus.includes(statusValue.value),
        }"
        @click.stop="select(statusValue.value)"
      >
        <span class="h-100 lisaui:flex lisaui:justify-center">
          <StatusCircleComponent style="height: 1.75rem" :status="index + 1" />
        </span>
        <p class="lisaui:m-0 p-1 lisaui:flex lisaui:justify-center">
          {{ statusValue.label }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, type PropType } from "vue";
import StatusCircleComponent from "@/components/event-action/task/StatusCircleComponent.vue";
import { SQDCActionStatus } from "@/graphql.ts";
import { useTranslation } from "@/language/translation";

const props = defineProps({
  status: {
    required: true,
    type: [String, Array] as PropType<SQDCActionStatus | SQDCActionStatus[]>,
  },
  multi: {
    required: false,
    type: Boolean,
    default: false,
  },
  disabled: {
    required: false,
    type: Boolean,
    default: false,
  },
});

const { t } = useTranslation();
const emit = defineEmits(["update:status"]);

const modalStatuses = ref([
  { label: t(`components.TaskModal.pdcaCircle1`), value: SQDCActionStatus.PLAN },
  { label: t(`components.TaskModal.pdcaCircle2`), value: SQDCActionStatus.DO },
  { label: t(`components.TaskModal.pdcaCircle3`), value: SQDCActionStatus.CHECK },
  { label: t(`components.TaskModal.pdcaCircle4`), value: SQDCActionStatus.ACT },
]);
if (props.multi !== Array.isArray(props.status)) {
  throw new Error(
    "if using StatusSelectComponent with multi, please provide an Array and vice versa",
  );
}
const multiStatus = computed<SQDCActionStatus[]>({
  get: () => {
    if (Array.isArray(props.status)) {
      return props.status;
    }
    return [props.status];
  },
  set: (val) => {
    if (props.multi) {
      emit("update:status", val);
    } else {
      emit("update:status", val[0]);
    }
  },
});

function select(index: SQDCActionStatus) {
  if (props.disabled) return;
  // Check if multi mode
  if (props.multi && Array.isArray(props.status)) {
    // If yes, check if the status array already includes the selected value
    if (props.status.includes(index)) {
      // emit the status array without the selected value
      emit(
        "update:status",
        props.status.filter((value) => value !== index),
      );
    } else {
      // add the selected value and sort the array
      emit("update:status", [...props.status, index].sort());
    }
  } else {
    // No multi mode. Just select the index
    emit("update:status", index);
  }
}
</script>

<style scoped lang="scss">
.selected-status {
  background-color: var(--p-surface-100);
}
</style>
